const PRODUCT = 'product';
const CHECK_IN = 'checkin';
const GENERAL = 'general';
const ENTRENAMIENTO = 'entrenamiento';
const CHECK_OUT = 'checkout';
const REQUEST = 'request';
const EXECUTION = 'execution';
const REVIEW = 'review';
const INVENTORY = 'inventory';
export {
  PRODUCT,
  CHECK_IN,
  GENERAL,
  ENTRENAMIENTO,
  CHECK_OUT,
  REQUEST,
  EXECUTION,
  REVIEW,
  INVENTORY,
};
